import { atom } from "recoil";
import { Calendar, Dirary } from "../types/dirary";

export const fetchManageStateForList = atom<boolean>({
  key: "fetchManageStateForList",
  default: false,
});
export const fetchManageStateForMatrix = atom<boolean>({
  key: "fetchManageStateForMatrix",
  default: false,
});
